module.exports = __webpack_public_path__ + "img/ce46b7e.png";